import {connect} from "react-redux";
import AccountAttributes from "./account";
import {bindActionCreators} from "redux";
import {dropdownData, saveAccount, accountDetailsById, updateAccount, fetchReportee} from "../../service/Account/action";
import {documentUploadUrlPublic} from "../../service/fileUpload/action";
import {locationPinCode, locationCity, locationZone, locationArea, stateAndRegion} from "../../service/locations/action";

const mapStateToProps = (state) => ({
    dropdownValue:state.Dropdown.dropdownValue,
    saveDetails:state.Dropdown.saveDetails,
    updateAccountDetails:state.Dropdown.updateAccountDetails,
    stateRegionDetails:state.Dropdown.stateRegionDetails,
    accountDetailsByIdData:state.Dropdown.accountDetailsById,
    reportee:state.Dropdown.reportee,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    pincodeData: state.locationReducer.pincodeData,
    cities: state.locationReducer.cities,
    zones: state.locationReducer.zones,
    areas: state.locationReducer.areas,
    latlng: state.currentLocationReducer.latlng,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            dropdownData,
            documentUploadUrlPublic,
            locationPinCode,
            locationCity,
            locationZone,
            locationArea,
            saveAccount,
            accountDetailsById,
            updateAccount,
            fetchReportee,
            stateAndRegion
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(AccountAttributes);
